import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../../lib/auth";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Button } from "../../components/ui/button";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim(), password);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="min-h-screen flex items-center justify-center px-6 pt-24 pb-16"
    >
      <div className="w-full max-w-md">
        <p className="overline mb-4 text-center">Host portal</p>
        <h1 className="font-serif-luxe text-5xl text-center leading-none">
          Welcome <span className="italic text-[#D4AF37]">back</span>.
        </h1>
        <form
          onSubmit={submit}
          className="mt-12 border border-[#F5F5DC]/10 bg-[#1C1C1E] p-8 space-y-5"
        >
          <div>
            <Label className="text-xs uppercase tracking-[0.2em] text-[#A3A3A3]">
              Email
            </Label>
            <Input
              data-testid="admin-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              required
              className="mt-2 bg-[#121212] border-[#F5F5DC]/10 focus:border-[#D4AF37]"
            />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-[0.2em] text-[#A3A3A3]">
              Password
            </Label>
            <Input
              data-testid="admin-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="mt-2 bg-[#121212] border-[#F5F5DC]/10 focus:border-[#D4AF37]"
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full h-12 bg-[#D4AF37] text-[#121212] hover:bg-[#B3922E] text-xs tracking-[0.24em] uppercase rounded-none"
          >
            {loading ? "Signing in…" : "Sign In"}
          </Button>
        </form>
      </div>
    </div>
  );
}
